import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { apiClient } from "../../services/apiClientService";
import { useUserAuth } from "../../context/UserAuthContext";

const UserProtectedRoute = ({ children }) => {
  const { isAuthenticated, login, logout, user } = useUserAuth();
  const location = useLocation();
  const [checkingSession, setCheckingSession] = useState(true);
  const hasChecked = useRef(false);

  useEffect(() => {
    const checkSession = async () => {
      if (hasChecked.current) {
        setCheckingSession(false);
        return;
      }

      hasChecked.current = true;

      try {
        const data = await apiClient("GET", "/api/users/profile");

        if (data?.email) {
          login(data); // user data directly
        } else {
          console.warn("Invalid user session. Logging out...");
          await logout();
        }
      } catch (error) {
        console.error("User session check failed:", error.message);
        await logout();
      } finally {
        setCheckingSession(false);
      }
    };

    if (!user) {
      checkSession();
    } else {
      setCheckingSession(false);
    }
  }, [login, logout, user]);

  if (checkingSession) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center p-10">Validating session...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/user-login" state={{ from: location }} replace />;
  }

  return children;
};

export default UserProtectedRoute;
